import React from "react";
import Icon from "components/Elements/Icon/Icon.tsx";
import useMediaQueries from "hooks/useMediaQueries.js";
import SimpleUploadModal from "../Modals/SimpleUploadModal.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import { useUploader } from "contexts/uploaderContext/uploaderContext.js";

const RemoveAllFilesComponent = () => {
  const { uploaderGetFiles, uploaderCancelAll } = useUploader();
  const { getTextByKey } = useContent();
  const { desktopCondition } = useMediaQueries();
  const { setModal, closeModal } = useModal();

  const handleRemoveAllFiles = () => {
    const callback = () => {
      uploaderCancelAll();
      closeModal();
    };
    setModal({
      modal: SimpleUploadModal,
      props: {
        icon: { name: "home/trash-solid-warning" },
        text: "remove-all-files-text",
        buttonText: "remove-all-files-button-text",
        buttonCallback: callback,
        isCancel: true,
      },
    });
  };

  const filesExist = uploaderGetFiles().length > 0;

  return filesExist ? (
    <button className="upload-remove-all-action" onClick={handleRemoveAllFiles}>
      {desktopCondition ? (
        getTextByKey("remove-all-text")
      ) : (
        <Icon name="home/trash" />
      )}
    </button>
  ) : null;
};
export default RemoveAllFilesComponent;
